import { Link } from "react-router-dom";
// ⚠️ Best-guess hook name — verify against generated v1.ts (Rule MKT-FE-05).
import { useV1MarketplaceListingsList } from "@/api/generated/v1/v1";
import type { Listing } from "@/api/generated/models";
import { PageBanner } from "@/shared/components/PageBanner";

export function ListingListPage() {
  const { data, isLoading, isError } = useV1MarketplaceListingsList();
  const listings = data?.results ?? [];

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="آگهی‌ها"
        subtitle="مدیریت و مشاهده آگهی‌های فروشگاه‌ها"
        icon="📢"
        helpLink="/help/marketplace/listings"
      >
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          <Link
            to="/marketplace/listings/new"
            style={{
              padding: "0.6rem 1.25rem",
              borderRadius: "12px",
              background: "#ffffff",
              color: "#007270",
              fontWeight: 700,
              fontSize: "0.9rem",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              transition: "all 0.2s ease",
              textDecoration: "none"
            }}
          >
            <span>➕</span>
            <span>آگهی جدید</span>
          </Link>
        </div>
      </PageBanner>

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        {isLoading && <p>در حال بارگذاری...</p>}
        {isError && <p style={{ color: "red" }}>خطا در دریافت آگهی‌ها.</p>}

        {!isLoading && !isError && listings.length === 0 && (
          <p style={{ textAlign: "center", color: "var(--color-text-muted)", padding: "2rem" }}>هیچ آگهی‌ای یافت نشد.</p>
        )}

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: "24px"
        }}>
          {listings.map((listing: Listing) => (
            <div key={listing.id} style={{ padding: "24px", display: "flex", flexDirection: "column", gap: "16px", background: "rgba(255,255,255,0.02)", borderRadius: "16px", border: "1px solid var(--glass-border)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h3 style={{ margin: 0 }}>
                  <Link to={`/marketplace/listings/${listing.id}`} style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}>آگهی #{listing.id}</Link>
                </h3>
                <span style={{
                  padding: "4px 12px",
                  borderRadius: "999px",
                  fontSize: "0.85rem",
                  fontWeight: "bold",
                  backgroundColor: listing.is_active ? "rgba(59, 122, 114, 0.1)" : "rgba(179, 66, 58, 0.1)",
                  color: listing.is_active ? "var(--color-success)" : "var(--color-error)",
                  border: `1px solid ${listing.is_active ? "var(--color-success)" : "var(--color-error)"}`
                }}>
                  {listing.is_active ? "فعال" : "غیرفعال"}
                </span>
              </div>
              
              <div style={{ borderTop: "1px solid var(--glass-border)", paddingTop: "16px" }}>
                <p style={{ margin: "0 0 8px 0", color: "var(--color-text-muted)", fontSize: "0.9rem" }}>قیمت فعال</p>
                <div style={{ fontSize: "1.25rem", fontWeight: "bold", color: "var(--color-text-main)" }}>
                  {listing.active_price
                    ? `${listing.active_price.base_price.toLocaleString()} ${listing.active_price.currency}`
                    : <span style={{ opacity: 0.5 }}>—</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
